import React from "react";

const QuestionMark = ({style = {}, size = "36", className = "", fill = "#73788B", viewBox = "0 0 36 36"}) => (
    <svg
        width={size}
        style={style}
        height={size}
        viewBox={viewBox}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={`${className || ""}`}
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >
      <path
          className="u_fill"
          d="M18 34C9.163 34 2 26.837 2 18S9.163 2 18 2s16 7.163 16 16-7.163 16-16 16zm-1.6-11.2V26h3.2v-3.2h-3.2zm3.2-2.632A5.604 5.604 0 0018 9.2a5.602 5.602 0 00-5.493 4.5l3.14.63A2.4 2.4 0 1118 17.2a1.6 1.6 0 00-1.6 1.6v2.4h3.2v-1.032z"
          fill={fill}
      />
    </svg>
);

export default QuestionMark;
